/**
 * @generated SignedSource<<8e90722657a9dcb92ec082aa9f84d517>>
 * @relayHash 9a3ef6a34dbc95fa4c0485dfc032615f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9a3ef6a34dbc95fa4c0485dfc032615f

import { ConcreteRequest } from 'relay-runtime';
export type AiResult = "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID" | "BREACHED_CONTENT_FILTER" | "FUNCTION_CALL" | "INVALID_QUESTIONNAIRE_DATA" | "JSON_ERROR" | "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED" | "MISSING_APPOINTMENT_DATA" | "MISSING_CALL_TRANSCRIPT" | "MISSING_CHAT_TRANSCRIPT" | "MISSING_CLINIBEE_GUIDELINES" | "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE" | "MISSING_QUESTIONNAIRE_DATA" | "MISSING_USER_INPUT" | "MISSING_USER_PROMPT" | "NOT_FOUND_OPEN_AI_PROMPT" | "PROCESS_TIMEOUT" | "SUCCESS" | "TOOL_CALLS" | "UNKNOWN_ERROR" | "UNRESOLVED_PLACEHOLDER" | "UNSUPPORTED_PLACEHOLDER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type AiRequestMetadataInput = {
  age: number;
  aiFeatureId: string;
  appointmentId: string;
  gender: Gender;
  progressNoteId?: string | null;
  progressNotes?: ReadonlyArray<ProgressNoteAnamnesisInput> | null;
  specialtyOfPointOfCareForCurrentProgressNote?: string | null;
  targetAgentLanguage?: Language | null;
  userInput?: string | null;
};
export type ProgressNoteAnamnesisInput = {
  anamnesis: string;
  updatedAt: string;
};
export type deNextBestQuestionsQuery$variables = {
  aiRequestMetadata: AiRequestMetadataInput;
};
export type deNextBestQuestionsQuery$data = {
  readonly nextBestQuestions: {
    readonly aiAnonymizationRequestDurationMs: number;
    readonly aiRequestDurationMs: number;
    readonly fileHash: string;
    readonly questions: ReadonlyArray<string>;
    readonly result: AiResult;
  };
};
export type deNextBestQuestionsQuery = {
  response: deNextBestQuestionsQuery$data;
  variables: deNextBestQuestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aiRequestMetadata"
  }
],
v1 = [
  {
    "alias": "nextBestQuestions",
    "args": [
      {
        "kind": "Variable",
        "name": "aiRequestMetadata",
        "variableName": "aiRequestMetadata"
      }
    ],
    "concreteType": "TextResults",
    "kind": "LinkedField",
    "name": "de_nextBestQuestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "questions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileHash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiRequestDurationMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiAnonymizationRequestDurationMs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deNextBestQuestionsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deNextBestQuestionsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "9a3ef6a34dbc95fa4c0485dfc032615f",
    "metadata": {},
    "name": "deNextBestQuestionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dbe971df1065c7a77da060fee71a68fb";

export default node;
